<template>
    <v-textarea
        v-bind="$attrs"
        v-on="$listeners"
        :rules="localRules"
    >
        <template
            v-if="label && !$slots.label"
            v-slot:label
        >
            <span
                v-if="required"
                class="required-symbol"
            >
                *
            </span>

            {{label}}
        </template>

        <slot
            v-for="(_, name) in $slots"
            :name="name"
            :slot="name"
        />

        <template
            v-for="(_, name) in $scopedSlots"
            v-slot:[name]="slotData"
        >
            <slot
                v-bind="slotData"
                :name="name"
            />
        </template>
    </v-textarea>
</template>

<script>
export default {
    name: "BaseInputTextarea",
    inheritAttrs: false,
    props: {
        label: {
            type: String,
        },
        required: {
            type: Boolean,
        },
        rules: {
            type: Array,
        },
    },
    data() {
        return {
            localRules: [],
            requiredRule: [(v) => !!v || 'Required'],
        }
    },
    created() {
        if (this.required) {
            this.localRules = this.localRules.concat(this.requiredRule);
        }

        if (this.rules) {
            this.localRules = this.localRules.concat(this.rules);
        }
    },
}
</script>
